import React from 'react';
import { Loader } from '@pwc/pwc-deals-ui';
import { deviceViewportNames } from '../../constants/DeviceViewports';
import useDeviceViewport from '../../hooks/useDeviceViewport';

const ResponsiveLoader = ({ dataTestId }) => {
  const calculatedDeviceViewport = useDeviceViewport();
  return (
    <Loader
      dataTestId={dataTestId}
      className={`${
        calculatedDeviceViewport === deviceViewportNames.mobileL ||
        calculatedDeviceViewport === deviceViewportNames.mobile
          ? 'small'
          : ''
      }`}
    />
  );
};

export default ResponsiveLoader;
